import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setLocationSiteHistoryLogsLoading
    , getLocationSiteHistoryLogs
    , setLocationSiteHistoryPageSize
    , resetLocationSiteHistory
    , setLocationSiteColSearchStr
} from '../../../../constants/model-reducers/external/inventory/locationsite/locationsite-history.settings';

import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const locationSiteHistoryActions = {
    getLocationSiteHistoryLogs: (LocationId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().locationHistory.HistoryTable;
        var formData = {
            LocationId: LocationId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers
        };

        dispatch({
            type: setLocationSiteHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/inventory/getLocationSiteHistoryLogs', formData);

        dispatch({
            type: getLocationSiteHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },

    resizeLocationSiteHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setLocationSiteHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractLocationHistoryLogs: (LocationId) => async (dispatch, state) => {
        const { Headers } = state().locationHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Location Site History – ${formattedTimeZoneDate}`;

        var formData = {
            LocationId: LocationId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/inventory/getExtractLocationSiteHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    setLocationSiteColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().locationHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setLocationSiteColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    resetLocationSiteHistory: () => (dispatch, state) => {
        dispatch({
            type: resetLocationSiteHistory
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setLocationSiteHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getLocationSiteHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setLocationSiteHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setLocationSiteColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetLocationSiteHistory:
            return initialState;
        default:
            return state;
    }
}